<template>
  <div class="schedule-wrapper">
  <section v-if="dataDetailStatus === null" class="schedule-card schedule-loading-card">
    <i class="fa fa-spinner fa-spin"></i>
    Memuat status pengiriman otomatis...
  </section>
  <section v-else class="schedule-card">
    <div class="schedule-card-main">
      <div class="schedule-icon" :class="{ 'is-active': isEnabled }">
        <i class="fa fa-calendar-check-o"></i>
      </div>

      <div class="schedule-copy">
        <div class="schedule-title-row">
          <h3>Pengiriman otomatis {{ isEnabled ? "aktif" : "nonaktif" }}</h3>
          <span class="schedule-status" :class="isEnabled ? 'is-on' : 'is-off'">
            {{ isEnabled ? "ON" : "OFF" }}
          </span>
        </div>

        <p v-if="!isConfigured" class="schedule-description">
          Fitur Momen Spesial belum diaktifkan. Aktifkan fitur dan atur jam
          pengiriman otomatis.
        </p>
        <p v-else-if="isEnabled && scheduleTime" class="schedule-description">
          Dijalankan setiap hari pukul
          <strong>{{ scheduleTime }} WIB</strong>.
        </p>
        <p v-else-if="isEnabled" class="schedule-description">
          Pengiriman otomatis aktif, tetapi jadwal pengiriman belum diatur.
        </p>
        <p v-else class="schedule-description">
          Pengiriman otomatis sedang nonaktif. Aktifkan untuk menjalankan
          ucapan dan promo sesuai jadwal.
        </p>

        <p v-if="isConfigured && isEnabled && !scheduleTime" class="schedule-warning">
          <i class="fa fa-exclamation-triangle"></i>
          Atur jam pengiriman agar pesan tidak dikirim pada waktu yang tidak
          diinginkan.
        </p>

        <p v-if="errorMessage" class="schedule-error" role="alert">
          <i class="fa fa-exclamation-circle"></i>
          {{ errorMessage }}
        </p>
      </div>
    </div>

    <div class="schedule-controls">
      <div class="schedule-time-box">
        <i class="fa fa-clock-o"></i>
        <div>
          <span>Jadwal pengiriman</span>
          <strong>{{ scheduleTime ? "Setiap hari · " + scheduleTime : "Belum dijadwalkan" }}</strong>
          <small>WIB (GMT+7)</small>
        </div>
      </div>

      <div class="schedule-toggle">
        <span>{{ isEnabled ? "ON" : "OFF" }}</span>
        <button
          type="button"
          class="schedule-switch"
          :class="{ 'is-on': isEnabled }"
          :disabled="saving || loadingStatus"
          role="switch"
          :aria-checked="isEnabled ? 'true' : 'false'"
          :aria-label="isEnabled ? 'Nonaktifkan pengiriman otomatis' : 'Aktifkan pengiriman otomatis'"
          @click="toggleSchedule"
        >
          <span class="schedule-switch-knob"></span>
          <i v-if="saving" class="fa fa-spinner fa-spin"></i>
        </button>
      </div>

      <button
        type="button"
        class="btn schedule-btn"
        :disabled="saving || loadingStatus"
        @click="openScheduleModal"
      >
        <i class="fa" :class="saving ? 'fa-spinner fa-spin' : 'fa-cog'"></i>
        {{ isConfigured ? "Atur Jadwal" : "Aktifkan & Atur Jadwal" }}
      </button>
    </div>

    <div v-if="saving" class="schedule-saving">
      <i class="fa fa-spinner fa-spin"></i>
      Menyimpan perubahan...
    </div>
  </section>

  <a
    v-show="false"
    ref="openModal"
    href="#"
    data-toggle="modal"
    data-target="#schedule_modal"
  ></a>

  <div
    id="schedule_modal"
    class="modal fade schedule-modal"
    role="dialog"
    aria-labelledby="scheduleModalTitle"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="schedule-modal-title">
            <span><i class="fa fa-clock-o"></i></span>
            <div>
              <h5 id="scheduleModalTitle" class="modal-title">Atur Jadwal Pengiriman</h5>
              <p>Atur jam pengiriman otomatis untuk Momen Spesial.</p>
            </div>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Tutup" :disabled="saving">
            <span aria-hidden="true">&times;</span>
          </button>
          <button
            ref="dismissModal"
            type="button"
            class="d-none"
            data-dismiss="modal"
            aria-hidden="true"
          ></button>
        </div>

        <div class="modal-body">
          <div v-if="!isConfigured" class="schedule-modal-note">
            <i class="fa fa-info-circle"></i>
            Fitur Momen Spesial belum aktif. Menyimpan jadwal akan mengaktifkan
            fitur ini terlebih dahulu.
          </div>

          <div class="schedule-modal-status">
            <div>
              <span>Status pengiriman otomatis</span>
              <strong :class="isEnabled ? 'is-on' : 'is-off'">
                {{ isEnabled ? "Aktif" : "Nonaktif" }}
              </strong>
            </div>
            <span class="schedule-modal-status-hint">
              Status diubah dari panel utama.
            </span>
          </div>

          <div class="schedule-time-picker">
            <label>Jam pengiriman</label>
            <div class="schedule-time-selects">
              <select v-model="draftHour" aria-label="Jam pengiriman">
                <option v-for="hour in hourOptions" :key="'hour-' + hour" :value="hour">
                  {{ hour }}
                </option>
              </select>
              <span>:</span>
              <select v-model="draftMinute" aria-label="Menit pengiriman">
                <option v-for="minute in minuteOptions" :key="'minute-' + minute" :value="minute">
                  {{ minute }}
                </option>
              </select>
              <span class="schedule-timezone">WIB</span>
            </div>
            <small>Gunakan format 24 jam. Zona waktu mengikuti WIB (GMT+7).</small>
          </div>

          <div class="schedule-summary">
            <i class="fa fa-calendar"></i>
            <div>
              <span>Ringkasan jadwal</span>
              <strong>Setiap hari pukul {{ selectedTime }} WIB</strong>
            </div>
          </div>

          <div v-if="!isEnabled" class="schedule-modal-warning">
            <i class="fa fa-exclamation-triangle"></i>
            Pengiriman otomatis sedang OFF. Menyimpan jam tidak akan
            mengaktifkan pengiriman; aktifkan lewat panel utama jika diperlukan.
          </div>

          <div v-if="modalError" class="schedule-modal-error" role="alert">
            <i class="fa fa-exclamation-circle"></i>
            {{ modalError }}
          </div>
        </div>

        <div class="modal-footer schedule-modal-actions">
          <button
            type="button"
            class="btn schedule-btn-secondary"
            data-dismiss="modal"
            :disabled="saving"
          >
            Batal
          </button>
          <button
            type="button"
            class="btn schedule-btn-primary"
            :disabled="saving"
            @click="saveSchedule"
          >
            <i class="fa" :class="saving ? 'fa-spinner fa-spin' : 'fa-check'"></i>
            {{ saving ? "Menyimpan..." : "Simpan" }}
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import {
  convertUTCDatetimeToUnix,
  formatHourFromUnix
} from "@/utils/helper";

const HOURS = Array.from({ length: 24 }, function(_, index) {
  return String(index).padStart(2, "0");
});
const MINUTES = Array.from({ length: 60 }, function(_, index) {
  return String(index).padStart(2, "0");
});

export default {
  name: "MomentSchedule",
  props: {
    dataDetailStatus: {
      type: Object,
      default: () => null
    },
    detailStatus: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      saving: false,
      loadingStatus: false,
      errorMessage: "",
      modalError: "",
      draftHour: "10",
      draftMinute: "00",
      hourOptions: HOURS,
      minuteOptions: MINUTES
    };
  },
  computed: {
    isConfigured() {
      return Boolean(
        this.dataDetailStatus &&
          this.dataDetailStatus.id !== "" &&
          this.dataDetailStatus.id !== null &&
          typeof this.dataDetailStatus.id !== "undefined"
      );
    },
    isEnabled() {
      return Boolean(this.isConfigured && Number(this.dataDetailStatus.is_publish) === 1);
    },
    scheduleTime() {
      const raw = this.dataDetailStatus && this.dataDetailStatus.recurrence_time;
      if (!raw) return "";
      if (/^\d{2}:\d{2}$/.test(String(raw))) {
        return String(raw);
      }
      const unix = convertUTCDatetimeToUnix(raw);
      const formatted = formatHourFromUnix(unix);
      if (!formatted || formatted === "Invalid date") {
        return "";
      }
      return formatted;
    },
    selectedTime() {
      return this.draftHour + ":" + this.draftMinute;
    }
  },
  methods: {
    getErrorMessage(error, fallback) {
      let message = "";
      if (error && error.response && error.response.data) {
        message =
          error.response.data.msg ||
          error.response.data.message ||
          "";
      }
      if (!message && error && error.message) {
        message = error.message;
      }
      message = String(message)
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/<[^>]*>/g, "")
        .trim();
      if (!message || /sql|select |table|column|backend|redis|worker|stack|trace|invalid|failed|error/i.test(message)) {
        return fallback;
      }
      return message;
    },
    async refreshStatus() {
      if (typeof this.detailStatus !== "function") return;
      this.loadingStatus = true;
      try {
        await this.detailStatus();
      } finally {
        this.loadingStatus = false;
      }
    },
    async toggleSchedule() {
      if (this.saving) return;
      const target = this.isEnabled ? 0 : 1;
      this.saving = true;
      this.errorMessage = "";
      try {
        await this.$store.dispatch("birthdayGreetings/storedIsEnable", {
          is_publish: target
        });
        await this.refreshStatus();
        if (target === 1 && !this.scheduleTime) {
          this.openModalNow();
        }
      } catch (error) {
        this.errorMessage = this.getErrorMessage(
          error,
          "Status pengiriman otomatis belum dapat diubah. Coba lagi."
        );
        this.$fire({
          title: "Gagal",
          text: this.errorMessage,
          type: "error",
          timer: 3500
        });
      } finally {
        this.saving = false;
      }
    },
    async activateFeature() {
      this.saving = true;
      this.errorMessage = "";
      try {
        await this.$store.dispatch("birthdayGreetings/storedIsEnable", {
          is_publish: 1
        });
        await this.refreshStatus();
        return true;
      } catch (error) {
        this.errorMessage = this.getErrorMessage(
          error,
          "Fitur belum dapat diaktifkan. Coba lagi."
        );
        this.$fire({
          title: "Gagal",
          text: this.errorMessage,
          type: "error",
          timer: 3500
        });
        return false;
      } finally {
        this.saving = false;
      }
    },
    async openScheduleModal() {
      if (this.saving) return;
      if (!this.isConfigured) {
        const activated = await this.activateFeature();
        if (!activated) return;
      }
      this.openModalNow();
    },
    openModalNow() {
      const time = this.scheduleTime || "10:00";
      const parts = time.split(":");
      this.draftHour = HOURS.indexOf(parts[0]) !== -1 ? parts[0] : "10";
      this.draftMinute = MINUTES.indexOf(parts[1]) !== -1 ? parts[1] : "00";
      this.modalError = "";
      this.$nextTick(() => {
        if (this.$refs.openModal) {
          this.$refs.openModal.click();
        }
      });
    },
    closeModal() {
      if (this.$refs.dismissModal) {
        this.$refs.dismissModal.click();
      }
    },
    async saveSchedule() {
      if (this.saving) return;
      this.modalError = "";
      if (HOURS.indexOf(this.draftHour) === -1 || MINUTES.indexOf(this.draftMinute) === -1) {
        this.modalError = "Jam dan menit pengiriman tidak valid.";
        return;
      }

      this.saving = true;
      try {
        if (!this.isConfigured) {
          await this.$store.dispatch("birthdayGreetings/storedIsEnable", {
            is_publish: 1
          });
          await this.refreshStatus();
        }

        const statusId = this.dataDetailStatus && this.dataDetailStatus.id;
        if (!statusId) {
          throw new Error("ID konfigurasi jadwal tidak tersedia.");
        }

        await this.$store.dispatch("birthdayGreetings/storedSetTime", {
          id: statusId,
          recurrence_time: this.selectedTime
        });
        await this.refreshStatus();
        this.closeModal();
        setTimeout(() => {
          const modal = document.getElementById("schedule_modal");
          if (modal && modal.classList.contains("show")) {
            this.closeModal();
          }
        }, 350);
        this.$fire({
          title: "Berhasil",
          text: "Jadwal pengiriman otomatis berhasil disimpan.",
          type: "success",
          timer: 3000
        });
      } catch (error) {
        this.modalError = this.getErrorMessage(
          error,
          "Jadwal pengiriman belum dapat disimpan. Coba lagi."
        );
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.schedule-loading-card {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #667085;
  font-size: 12px;
}

.schedule-loading-card i {
  color: #b36b00;
}

.schedule-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  padding: 16px 18px;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.03);
}

.schedule-card-main {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex: 1 1 420px;
  min-width: 0;
}

.schedule-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 12px;
  font-size: 19px;
}

.schedule-icon.is-active {
  color: #067647;
  background: #ecfdf3;
  border-color: #bbf7d0;
}

.schedule-copy {
  min-width: 0;
}

.schedule-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.schedule-title-row h3 {
  margin: 0;
  color: #101828;
  font-size: 17px;
  font-weight: 700;
}

.schedule-status {
  display: inline-flex;
  align-items: center;
  height: 21px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
}

.schedule-status.is-on {
  color: #067647;
  background: #ecfdf3;
  border: 1px solid #bbf7d0;
}

.schedule-status.is-off {
  color: #8a5a00;
  background: #fff8e6;
  border: 1px solid #f3d28d;
}

.schedule-description {
  max-width: 620px;
  margin: 4px 0 0;
  color: #667085;
  font-size: 13px;
  line-height: 1.5;
}

.schedule-description strong {
  color: #344054;
}

.schedule-warning,
.schedule-error {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.45;
}

.schedule-warning { color: #b36b00; }
.schedule-error { color: #b42318; }

.schedule-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.schedule-time-box {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 190px;
  padding: 9px 11px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 10px;
}

.schedule-time-box > i {
  color: #667085;
  font-size: 16px;
}

.schedule-time-box span,
.schedule-time-box small {
  display: block;
  color: #98a2b3;
  font-size: 10px;
}

.schedule-time-box strong {
  display: block;
  color: #344054;
  font-size: 12px;
}

.schedule-toggle {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #667085;
  font-size: 11px;
  font-weight: 700;
}

.schedule-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 46px;
  height: 25px;
  padding: 2px;
  background: #d0d5dd;
  border: 0;
  border-radius: 999px;
  transition: background 0.18s ease;
}

.schedule-switch.is-on {
  background: #12b76a;
}

.schedule-switch:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.schedule-switch-knob {
  width: 21px;
  height: 21px;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.2);
  transition: transform 0.18s ease;
}

.schedule-switch.is-on .schedule-switch-knob {
  transform: translateX(21px);
}

.schedule-switch > i {
  position: absolute;
  left: 50%;
  top: 50%;
  color: #ffffff;
  font-size: 10px;
  transform: translate(-50%, -50%);
}

.schedule-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 38px;
  padding: 0 13px;
  color: #344054;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 9px;
  font-size: 12px;
  font-weight: 700;
}

.schedule-btn:hover,
.schedule-btn:focus {
  color: #b36b00;
  background: #fffaf0;
  border-color: #f2ce91;
}

.schedule-saving {
  flex: 1 0 100%;
  color: #b36b00;
  font-size: 11px;
}

.schedule-saving i {
  margin-right: 5px;
}

.schedule-modal .modal-content {
  overflow: hidden;
  border: 1px solid #e7edf5;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
}

.schedule-modal .modal-header {
  align-items: flex-start;
  padding: 18px 20px;
  border-bottom: 1px solid #eef1f4;
}

.schedule-modal-title {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.schedule-modal-title > span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 10px;
  font-size: 17px;
}

.schedule-modal-title h5 {
  margin: 0 0 2px;
  color: #101828;
  font-size: 18px;
  font-weight: 700;
}

.schedule-modal-title p {
  margin: 0;
  color: #667085;
  font-size: 12px;
}

.schedule-modal .modal-body {
  padding: 18px 20px;
}

.schedule-modal-note,
.schedule-modal-warning,
.schedule-modal-error {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 13px;
  padding: 10px 12px;
  border-radius: 9px;
  font-size: 12px;
  line-height: 1.5;
}

.schedule-modal-note {
  color: #175cd3;
  background: #eff8ff;
  border: 1px solid #b2ddff;
}

.schedule-modal-warning {
  color: #8a5a00;
  background: #fff8e6;
  border: 1px solid #f3d28d;
}

.schedule-modal-error {
  margin: 12px 0 0;
  color: #b42318;
  background: #fff5f5;
  border: 1px solid #f5b5b5;
}

.schedule-modal-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 14px;
  padding: 11px 13px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 10px;
}

.schedule-modal-status span {
  display: block;
  color: #667085;
  font-size: 11px;
}

.schedule-modal-status strong {
  display: block;
  margin-top: 2px;
  font-size: 14px;
}

.schedule-modal-status strong.is-on { color: #067647; }
.schedule-modal-status strong.is-off { color: #b36b00; }

.schedule-modal-status-hint {
  color: #98a2b3 !important;
  font-size: 10px !important;
}

.schedule-time-picker label {
  display: block;
  margin-bottom: 6px;
  color: #344054;
  font-size: 12px;
  font-weight: 600;
}

.schedule-time-selects {
  display: flex;
  align-items: center;
  gap: 7px;
}

.schedule-time-selects select {
  width: 72px;
  height: 40px;
  padding: 0 8px;
  color: #344054;
  background: #ffffff;
  border: 1px solid #dfe3e8;
  border-radius: 9px;
  font-size: 14px;
}

.schedule-timezone {
  color: #667085;
  font-size: 12px;
  font-weight: 700;
}

.schedule-time-picker small {
  display: block;
  margin-top: 5px;
  color: #98a2b3;
  font-size: 11px;
}

.schedule-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
  padding: 11px 13px;
  color: #344054;
  background: #fffaf1;
  border: 1px solid #f6d49b;
  border-radius: 10px;
}

.schedule-summary > i {
  color: #b36b00;
  font-size: 16px;
}

.schedule-summary span {
  display: block;
  color: #8f5600;
  font-size: 10px;
}

.schedule-summary strong {
  display: block;
  margin-top: 1px;
  font-size: 13px;
}

.schedule-modal-actions {
  padding: 14px 20px 18px;
  border-top: 1px solid #eef1f4;
}

.schedule-btn-secondary,
.schedule-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 38px;
  padding: 0 14px;
  border-radius: 9px;
  font-size: 12px;
  font-weight: 700;
}

.schedule-btn-secondary {
  color: #475467;
  background: #ffffff;
  border: 1px solid #e7edf5;
}

.schedule-btn-secondary:hover {
  color: #b36b00;
  background: #fffaf0;
  border-color: #f2ce91;
}

.schedule-btn-primary {
  color: #ffffff;
  background: #f39c12;
  border: 1px solid #f39c12;
}

.schedule-btn-primary:hover {
  background: #e08b13;
  border-color: #e08b13;
}

.schedule-btn-primary:disabled,
.schedule-btn-secondary:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

@media (max-width: 767px) {
  .schedule-card {
    align-items: stretch;
    flex-direction: column;
  }

  .schedule-card-main {
    flex: 0 0 auto;
  }

  .schedule-controls {
    align-items: stretch;
  }

  .schedule-time-box {
    flex: 1 1 100%;
  }

  .schedule-toggle {
    flex: 1 1 auto;
    justify-content: flex-start;
  }

  .schedule-btn {
    flex: 1 1 auto;
    justify-content: center;
  }

  .schedule-modal .modal-content {
    max-height: calc(100vh - 16px);
    overflow-y: auto;
  }

  .schedule-modal-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .schedule-modal-actions .btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/automation/birthdayGreetings/components/schedule.vue